import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import {
  isSupportedCardSet,
  type SupportedCardSet,
} from '#src/lib/cardSets.ts';
import { glossary } from '#src/lib/glossary.ts';
import { COMMON_GAME_SET } from '#src/set/index.ts';

import type { CardSetLabel_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet: Nullable<CardSetLabel_cardSet>;
};

const style: Record<SupportedCardSet, React.CSSProperties> = {
  [COMMON_GAME_SET.cardSet.baseSlug]: {},
  [COMMON_GAME_SET.cardSet.activeSlug]: {
    background:
      'linear-gradient(315deg, var(--c-set-main-color) 14.64%, #e8ecee 85.36%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
  },
};

export const CardSetLabel = ({ cardSet }: Props) => {
  if (!cardSet) {
    return null;
  }
  return (
    <span style={isSupportedCardSet(cardSet.slug) ? style[cardSet.slug] : {}}>
      <FormattedMessage
        {...glossary.setEdition}
        values={{
          set: cardSet.name,
        }}
      />
    </span>
  );
};

CardSetLabel.fragments = {
  cardSet: gql`
    fragment CardSetLabel_cardSet on CardSet {
      slug
      name
    }
  ` as TypedDocumentNode<CardSetLabel_cardSet>,
};
